import './app.less';

import commonModule from './common/common.module';
import componentsModule from './components/components.module';

import config from './app.config';
import routes from './app.routes';
import runFn from './app.run';

import mainComponent from './main/main.component';

import AppActionHandler from './app.action-handler.service';
import buyModule from './buy/buy.module';
import noAuthModule from './no-auth/no-auth.module';
import ErrorMessageHandler from './common/services/error/error.message.handler';
import loginModule from './login/login.module';
import manageSubscriptionModule from './manage-subscription/manage-subscription.module';
import myAccountModule from './my-account/my-account.module';
import packetModule from './packet/packet.module';
import UtilService from './common/services/util.service';
import { loadGoogleTags } from './common/services/analytics/google-tags.loader';
import familyPlanModule from './family-plan/family-plan.module';
import familyPlanMemberModule from './family-plan/family-plan-member/family-plan-member.module';
import familyPlanInfoModule from './family-plan/family-plan-info/family-plan-info.module';
import familyPlanMemberInfoModule from './family-plan/family-plan-member-info/family-plan-member-info.module';
import familyPlanAboutModule from './family-plan/family-plan-about-dialog/family-plan-about-dialog.module';

const configFilePath = 'config.json';
const injector = angular.injector(['ng'], true);

const rootModule = angular
  .module('fizyweb.paycell', [
    'ngAnimate',
    'ngCookies',
    'LocalStorageModule',
    'ngTouch',
    'ngSanitize',
    'ngMessages',
    'ngAria',
    'ngResource',
    'ui.router',
    'ng.deviceDetector',
    'ngMeta',
    'pascalprecht.translate',
    'ngMask',
    componentsModule,
    commonModule,
    myAccountModule,
    packetModule,
    manageSubscriptionModule,
    buyModule,
    noAuthModule,
    loginModule,
    familyPlanModule,
    familyPlanInfoModule,
    familyPlanMemberModule,
    familyPlanMemberInfoModule,
    familyPlanAboutModule
  ])
  .config(config)
  .config(setCookieComesFromMobile)
  .config(routes)
  .run(runFn)
  .service('appActionHandler', AppActionHandler)
  .service('errorMessageHandler', ErrorMessageHandler)
  .component('mainWrapper', mainComponent) 
  .factory('myInterceptor', [
    // tslint:disable-next-line:only-arrow-functions
    function() {
      return {
        request(config) {
          if (environment === 'prod' || environment === 'gprd') {
            const newConfig = config;
            newConfig.url = config.url.replace(
              '/hafifmuzik/mobile',
              'hafifmuzik/mobile'
            ).replace(
              'hafifmuzik/mobile',
              BEUrl + 'hafifmuzik/mobile'
            );
            return newConfig;
          } else {
            return config;
          }
        }
      };
    }
  ])
  .config([
    '$httpProvider',
    // tslint:disable-next-line:only-arrow-functions
    function($httpProvider) {
      $httpProvider.interceptors.push('myInterceptor');
    }
  ]);
let BEUrl;
let environment;
loadConfig().then(onConfigLoadedSuccessfully, onConfigLoadingError);

function loadConfig() {
  return injector.get('$http').get(configFilePath + '?v=' + generateV());

  function generateV() {
    const min = 1;
    const max = 1000000;
    return Math.floor(Math.random() * (max - min)) + min;
  }
}

function onConfigLoadedSuccessfully(response) {
  const cfg = angular.copy(response.data);
  BEUrl = response.data.backendServerUrl;
  environment = response.data.environment;
  loadGoogleTags(environment);
  cfg.api = buildApiUrls(cfg.api);

  angular.module('fizyweb.paycell').constant('config', cfg);
  bootstrapApplication();

  function buildApiUrls(apiItem) {
    if (angular.isObject(apiItem)) {
      const retObj = {};

      angular.forEach(apiItem, applyToRetObj(retObj));
      return retObj;
    } else {
      return apiItem;
    }

    function applyToRetObj(retObj) {
      return (value, key) => {
        if (key !== 'params' && key !== 'parameters' && key !== 'headers') {
          retObj[key] = buildApiUrls(value);
        } else {
          retObj[key] = value;
        }
      };
    }
  }
}

function onConfigLoadingError(errorResponse) {
  injector
    .get('$log')
    .error(
      'App initialization failed because the following error occurred while trying to load the config file: ',
      errorResponse.data
    );
}

function bootstrapApplication() {
  angular.element(document).ready(() => {
    angular.bootstrap(document, [rootModule.name]);
  });
}

// functions to set cookies from url if user come from mobile device with his own cookies in url
// the cookies name in cookiesNamesFromMobile will be replace on names from cookiesNamesToServe
// the order in cookiesNamesFromMobile and cookiesNamesToServe is IMPORTANT!
function setCookieComesFromMobile(config) {
  const { cookiesNamesFromMobile } = config;
  const { cookiesNamesToServe } = config;
  const { cookieDomain } = config;
  const packageIds = UtilService.getUrlParameter('campaignedPackageIds');
  if (!!packageIds) {
    localStorage.setItem('campaignedPackageIds', packageIds);
    const clean_uri = window.location.href.replace('?campaignedPackageIds=' + packageIds, '').replace('&campaignedPackageIds=' + packageIds, '');
    window.history.replaceState({}, document.title, clean_uri);
  }

  if (!hasAnyNewCookie(window.location.href, cookiesNamesFromMobile)) {
    return;
  } else{
    localStorage.setItem('showInApp', '1');
    localStorage.removeItem('advertisementId');
    localStorage.removeItem('gp_adid');
    localStorage.removeItem('encryptedMsisdn');
  }
  const adId = UtilService.getUrlParameter('adid');
  const gpAdid = UtilService.getUrlParameter('gp_adid');
  const encryptedMsisdn = UtilService.getUrlParameter('encryptedMsisdn');
  if (!!adId) {
    localStorage.setItem('advertisementId', adId);
    localStorage.setItem('gp_adid', gpAdid);
    localStorage.setItem('encryptedMsisdn', encryptedMsisdn);
  }

  removeSessionCookies(cookieDomain);

  const newCookies: string[] = convertCookiesNamesToServer(
    getCookiesFromUrl(window.location.href, cookiesNamesFromMobile),
    cookiesNamesFromMobile,
    cookiesNamesToServe
  );
  setNativeCookiesFromUrl(newCookies, cookieDomain);
}

function hasAnyNewCookie(url: string, cookiesNames: string[]): boolean {
  return cookiesNames.some((cookieName: string) => {
    return window.location.href.indexOf(cookieName) !== -1;
  });
}

function getCookiesFromUrl(url: string, cookiesNamesArr: string[]): string[] {
  return url
    .split('?')[1]
    .split('&')
    .filter((query: string) => {
      const queryName = query.split('=')[0];
      return cookiesNamesArr.indexOf(queryName) !== -1;
    });
}

function convertCookiesNamesToServer(
  cookies: string[],
  cookiesNamesFromMobile: string[],
  cookiesNamesToServer: string[]
): string[] {
  return cookies.map((cookie: string, index) => {
    return cookie.replace(
      cookiesNamesFromMobile[index],
      cookiesNamesToServer[index]
    );
  });
}

function setNativeCookiesFromUrl(newCookiesArr: string[], cookieDomain: string) {
  newCookiesArr.forEach((cookie: string) => {
      document.cookie = cookie +";domain=" + cookieDomain + ";";
  });
}


function removeSessionCookies(cookieDomain: string){
  document.cookie = "otp_atkn=;expires=Thu, 01 Jan 1970 00:00:00 UTC;domain=" + cookieDomain + ";";
  document.cookie = "otp_rtkn=;expires=Thu, 01 Jan 1970 00:00:00 UTC;domain=" + cookieDomain + ";";
}


// WEBPACK FOOTER //
// ./src/app/app.module.ts